var $name="analytics/isEnabled",$path="app/modules/analytics/isEnabled.js",$this={$name,$path,};import isObject from 'lodash/isObject';

const isAnalyticsEnabled = () => isObject(window.sdlGoogleAnalyticConfig);

export default isAnalyticsEnabled;
